import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Viewer, { SpecialZoomLevel, Worker } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import CustomModal from "components/Modal/CustomModal";
import React from "react";

interface IDialogPDFReader {
  open: boolean;
  link: string;
  handleClose: () => void;
  title?: string;
}

export default function DialogPDFReader({ open, link = "", handleClose, title = "" }: IDialogPDFReader) {
  return (
    <CustomModal
      open={open}
      backLabel={
        <>
          <ArrowBackIosIcon style={{ textAlign: "center", marginLeft: "1vw", fontSize: "1.3rem" }} />
          {title}
        </>
      }
      onClose={handleClose}
      children={
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js">
          <div style={{ height: "750px", width: "100%" }}>
            <Viewer fileUrl={link} defaultScale={SpecialZoomLevel.PageFit} />
          </div>
        </Worker>
      }
    />
  );
}
